/* Polsk katalog for locale-investment-inbox.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'investments.inboxTitle': 'Skrzynka odbiorcza',
  'investments.inboxIntro': 'Prześlij dokumenty kupna i sprzedaży funduszy oraz akcji. Plumme odczyta dokument i przygotuje rejestrację.',
  'investments.supportNotice': 'Fundusze i akcje są w pełni obsługiwane w zakresie rejestracji i księgowania. Inne rodzaje inwestycji mogą zostać rozpoznane, ale na razie wymagają ręcznej obsługi.',
  'investments.sendToEmail': 'Wyślij na',
  'investments.copyEmail': 'Kopiuj adres e-mail',
  'investments.folder': 'Folder',
  'investments.inboxFolder': 'Skrzynka odbiorcza',
  'investments.trashFolder': 'Kosz',
  'investments.documentationFolder': 'Dokumentacja',
  'investments.searchDocuments': 'Szukaj w dokumentach',
  'investments.emptyFolder': 'W tym folderze nie ma dokumentów.',
  'investments.documentNotAnalyzed': 'Gotowe do analizy',
  'investments.superPlummaProposal': 'Propozycja od SuperPlumma',
  'investments.reviewAndApprove': 'Sprawdź i zatwierdź',
  'investments.notAnalyzedHelp': 'Dokument został odebrany i jest gotowy do analizy.',
  'investments.restoreDocument': 'Przywróć',
  'investments.sendToDocumentation': 'Przenieś do dokumentacji',
  'investments.moveToTrash': 'Przenieś do kosza',
  'investments.moreActions': 'Więcej działań',
  'investments.registerPurchase': 'Zarejestruj kupno',
  'investments.registerSale': 'Zarejestruj sprzedaż',
  'investments.tradeDate': 'Data transakcji',
  'investments.unitPrice': 'WAN / kurs',
  'investments.previewDocumentFallback': 'Dokument',
  'investments.previewMissingFileLink': 'Brak linku do pliku',
  'investments.openDocument': 'Otwórz dokument',
  'investments.addBankAccount': '+ Dodaj rachunek bankowy …',
  'investments.addBankTitle': 'Dodaj rachunek bankowy',
  'investments.addBankSave': 'Dodaj rachunek',
  'investments.newBankAccountNote': 'Nowy rachunek bankowy zostanie utworzony w planie kont',
  'investments.newBankAccountCode': 'Rachunek bankowy otrzyma następne wolne konto z serii 192x: {{code}}.',
  'investments.bankName': 'Nazwa rachunku',
  'investments.bankNamePlaceholder': 'Np. Rachunek inwestycyjny',
  'investments.bankAccountNumber': 'Numer rachunku',
  'investments.openingBalance': 'Saldo początkowe',
  'investments.openingBalanceDate': 'Data salda początkowego',
  'investments.bankNameRequired': 'Nadaj nazwę rachunkowi bankowemu.',
  'investments.bankNumberRequired': 'Wpisz numer rachunku.',
  'investments.bankOpeningRequired': 'Wpisz saldo początkowe i jego datę. Wpisz 0, jeśli saldo wynosiło zero.',
  'investments.bankNumberExists': 'Ten rachunek bankowy jest już zarejestrowany.',
  'investments.bankLedgerSeriesFull': 'W serii 192x nie ma wolnego konta. Dodaj konto w Ustawieniach.',
  'investments.bankAdded': 'Dodano rachunek bankowy.',
  'investments.addBankFailed': 'Nie udało się dodać rachunku bankowego.',
  'investments.addBankUnavailable': 'Rachunki bankowe nie są połączone z backendem.',
  'investments.addBankUnsupportedCountry': 'Ten proces rachunku bankowego jest na razie obsługiwany tylko dla norweskich firm.',
  'investments.newInvestmentAccount': 'Nowy rachunek inwestycyjny',
  'investments.investmentAccounts': 'Rachunki inwestycyjne i depozyty',
  'investments.settingsTab': 'Inwestycje',
  'investments.settingsTitle': 'Rachunki inwestycyjne i depozyty',
  'investments.settingsHelp': 'Zarządzaj rachunkami w bankach, towarzystwach funduszy i u innych dostawców.',
  'investments.editInvestmentAccount': 'Edytuj rachunek inwestycyjny',
  'investments.investmentAccountsHelp': 'Zarejestruj rachunki u każdego dostawcy. Ta sama inwestycja może być przechowywana w kilku depozytach, a konto w księdze głównej nadal jest czterocyfrowe.',
  'investments.noInvestmentAccounts': 'Nie zarejestrowano jeszcze żadnych rachunków inwestycyjnych.',
  'investments.saveInvestmentAccount': 'Zapisz rachunek inwestycyjny',
  'investments.investmentAccountId': 'Bank / depozyt',
  'investments.targetInvestmentAccountId': 'Nowy bank / depozyt',
  'investments.accountNumber': 'Numer rachunku lub depozytu (opcjonalnie)',
  'investments.defaultSettlementAccount': 'Domyślny rachunek rozliczeniowy',
  'investments.noDefaultSettlementAccount': 'Brak domyślnego rachunku rozliczeniowego',
  'investments.accountActive': 'Rachunek inwestycyjny jest aktywny',
  'investments.custody': 'Rachunek papierów wartościowych',
  'investments.fund_account': 'Rachunek funduszowy',
  'investments.other': 'Inny rachunek inwestycyjny',
  'investments.subledgerCode': 'Wewnętrzny numer inwestycji',
  'investments.createInstrumentFromDocument': '{{name}} (zostanie utworzony po zapisaniu)',
  'investments.providerHelp': 'Gdzie inwestycja jest przechowywana, na przykład Storebrand lub Nordnet. W razie potrzeby podaj numer depozytu.',
  'investments.settlementAccountHelp': 'Rachunek firmy, który został obciążony lub uznany. Rachunek gotówkowy u dostawcy trzeba zarejestrować jako osobny rachunek bankowy/rozliczeniowy w Ustawieniach. AS nie może korzystać z prywatnego rachunku oszczędnościowego akcji (ASK).',
  'investments.investmentAccountInvalid': 'Sprawdź nazwę, dostawcę i typ rachunku.',
  'investments.investmentAccountNotFound': 'Rachunek inwestycyjny nie istnieje lub jest nieaktywny.',
  'investments.investmentAccountDuplicate': 'Rachunek inwestycyjny o tej samej nazwie już istnieje.',
  'investments.investmentAccountRequired': 'Wybierz rachunek inwestycyjny, gdy dostawca ma kilka rachunków.',
  'investments.investmentAccountQuantityInvalid': 'Wybrany depozyt nie ma wystarczającej liczby zarejestrowanych jednostek dla tego zdarzenia.',
});
